import {UserAction, UserActionTypes} from "../user/UserActions";
import {UserRewardActions, UserRewardActionTypes} from "./UserRewardActions";
import {RequestState} from "../bonus/BonusReducer";
import {UserGameReward} from "../http/protocol";


export interface UserRewardState {
    rewards : UserGameReward[];
    rewardsStatus: RequestState
}

const initialState : UserRewardState = {
    rewards : [],
    rewardsStatus: RequestState.NONE
};

export function userRewardReducer (state = initialState, action: UserRewardActions|UserAction) : UserRewardState {
    switch (action.type) {
        case UserRewardActionTypes.REWARDS_REQUEST:
            return {...state, rewardsStatus : RequestState.IN_PROGRESS};
        case UserRewardActionTypes.REWARDS_ERROR:
            return {...state, rewardsStatus : RequestState.ERROR};
        case UserRewardActionTypes.REWARDS_RESPONSE:
            return {...state, rewardsStatus : RequestState.OK, rewards : action.rewards}
        case UserActionTypes.LOGOUT:
            return {...initialState};
        default:
            return state;
    }
}